<!-- One live region for every shape, so a screen reader hears the wait once. Bars are decoration. -->
<div class="skeleton" role="status" aria-busy="true" [attr.aria-label]="label()">
    @switch (type()) {
        @case ('table') {
            <span class="skeleton-bar skeleton-title"></span>
            <span class="skeleton-bar skeleton-head"></span>
            @for (row of rows; track $index) {
                <span class="skeleton-bar skeleton-row"></span>
            }
        }
        @case ('chart') {
            <span class="skeleton-bar skeleton-title"></span>
            <span class="skeleton-bar skeleton-plot"></span>
        }
        @case ('stat_list') {
            <div class="skeleton-tiles">
                @for (tile of tiles; track $index) {
                    <span class="skeleton-bar skeleton-tile"></span>
                }
            </div>
        }
        @case ('task_list') {
            <span class="skeleton-bar skeleton-title"></span>
            @for (task of tasks; track $index) {
                <span class="skeleton-bar skeleton-task"></span>
            }
        }
        @case ('actions') {
            <div class="skeleton-buttons">
                @for (button of buttons; track $index) {
                    <span class="skeleton-bar skeleton-button"></span>
                }
            </div>
        }
        @case ('callout') {
            <span class="skeleton-bar skeleton-callout"></span>
        }
        @case ('select') {
            <span class="skeleton-bar skeleton-title"></span>
            @for (option of options; track $index) {
                <span class="skeleton-bar skeleton-option"></span>
            }
        }
        <!-- A type this client predates. Something is coming; we cannot say what shape. -->
        @default {
            <span class="skeleton-bar skeleton-generic"></span>
        }
    }
</div>
